import { useState } from "react";
import { cn } from "./cn";

interface GifPreviewProps {
  url: string;
  className?: string;
}

export function GifPreview({ url, className }: GifPreviewProps) {
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);
  const [error, setError] = useState(false);

  if (error) {
    return null;
  }

  return (
    <div
      className={cn(
        "rounded-xl overflow-hidden bg-surface-2 relative max-w-[400px]",
        className
      )}
      style={{
        boxShadow: "inset 0 0 0 1px var(--color-border-tertiary)",
      }}
    >
      <img
        src={url}
        alt="GIF"
        className="w-full block"
        style={aspectRatio ? { aspectRatio: aspectRatio.toString() } : undefined}
        onLoad={(e) => {
          const img = e.target as HTMLImageElement;
          if (img.naturalWidth && img.naturalHeight) {
            setAspectRatio(img.naturalWidth / img.naturalHeight);
          }
        }}
        onError={() => setError(true)}
      />
    </div>
  );
}

export default GifPreview;
